import { Box, Button, Flex, Input, InputGroup, InputLeftElement, Text } from "@chakra-ui/react";
import React from "react";
import { RiAddFill, RiSearch2Fill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { openAddLiveVideo } from "../../../modules/admin-modules/models/Actions";

const C = {
  primary: "#6A1E1E",
  secondary: "#4A0F1F",
  border: "#D8CEC3",
  muted: "rgba(30, 27, 23, 0.6)",
};

const SearchBar = ({ setAdd, setSelectedData, searchTerm, setSearchTerm }) => {
  const dispatch = useDispatch();
  const count = useSelector((state) => state.adminLiveVideos.count);

  return (
    <Box px={{ base: 4, md: 8 }} pt={6} pb={0} w="100%">
      <Flex
        align={{ base: "flex-start", md: "flex-end" }}
        justify="space-between"
        gap={6}
        flexDir={{ base: "column", md: "row" }}
        mb={6}
      >
        <Box>
          <Text
            fontSize={{ base: "32px", md: "54px" }}
            fontWeight="800"
            color={C.primary}
            fontFamily="'Amiri', 'Tajawal', sans-serif"
            lineHeight="1"
          >
            Live sessions
          </Text>
          <Text mt={3} color={C.muted} fontSize="sm" maxW="lg">
            Scheduled live classes and Zoom links; open reports from the table.
          </Text>
          <Text mt={2} fontSize="sm" fontWeight="700" color={C.secondary}>
            Total: {count ?? 0}
          </Text>
        </Box>

        <Button
          borderRadius="full"
          leftIcon={<RiAddFill />}
          bg={C.primary}
          color="#FAF2EB"
          px={8}
          py={6}
          fontWeight="800"
          _hover={{ bg: C.secondary }}
          onClick={() => {
            setSelectedData({});
            setAdd(true);
            dispatch(openAddLiveVideo());
          }}
        >
          Add live session
        </Button>
      </Flex>

      <Box mb={6} maxW="520px">
        <InputGroup>
          <InputLeftElement pointerEvents="none" h="full">
            <RiSearch2Fill color="rgba(106, 30, 30, 0.5)" fontSize="18px" />
          </InputLeftElement>
          <Input
            placeholder="Search by title or link…"
            value={searchTerm}
            borderRadius="full"
            border="1px solid"
            borderColor={C.border}
            bg="rgba(255,255,255,0.85)"
            pl={10}
            _focus={{ borderColor: C.primary, boxShadow: "0 0 0 1px rgba(106, 30, 30, 0.2)" }}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </InputGroup>
      </Box>
    </Box>
  );
};

export default SearchBar;
